import {
  EDIT_COLLECTION_REQUEST, INVALIDATE_EDIT_COLLECTION_REQUEST,

  CREATE_COLLECTION_SECTION_REQUEST, UPDATE_COLLECTION_SECTION_REQUEST, REMOVE_COLLECTION_SECTION_REQUEST,

  FETCHING_COLLECTION_SECTION_REQUEST, FETCHING_COLLECTION_SECTION_SUCCEDDED,

  COLLECTION_ADD_ASSETS, COLLECTION_REMOVE_ASSETS, COLLECTION_REARRANGE_ASSETS,

  COLLECTION_MOVE_SECTIONS, COLLECTION_UPDATE_PROPERTY,

  COLLECTION_HIGHLIGHT_SECTION_DRAG_OVER, COLLECTION_MOVE_ASSET_BETWEEN_SECTIONS, INVALIDATE_COLLECTION_MOVE_ASSET_BETWEEN_SECTIONS,
  
  UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION
} from '../actions/actionTypes.jsx';
import { REPLACE_SIMILAR_ASSET_SUCCEEDED } from 'src/redux/actions/actionTypes.js';
import { EXPERIENCE_BENTO } from 'src/legacy/constants/collectionConstants';


import { guid } from 'src/utils/util';
import _ from 'lodash';

const initialState = {
  item: null,
  updating: false,
  move: {
    section: null,
    asset: null
  }
};

export function editCollectionReducer(state = initialState, action) {
  switch (action.type) {
    
    case EDIT_COLLECTION_REQUEST:
      var collection = action.payload.collection;
      
      return Object.assign({}, state, {
        ...state,
        item: collection
      })

      
    case INVALIDATE_EDIT_COLLECTION_REQUEST:
      var id = action.payload.id;

      if(!state.item || state.item.id != id){
        return state
      }

      return Object.assign({}, state, {
        ...initialState
      })

    case FETCHING_COLLECTION_SECTION_REQUEST:
      var id = action.payload.collection;
      var sectionId = action.payload.section;

      if (!state.item || state.item.id != id) {
        return state
      }

      var currentCollection = state.item;

      var sections = currentCollection.sections.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            loading: true,
            fetched: false
          }
        } else {
          return section;
        }
      })

      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          sections: sections
        }
      });  

    case FETCHING_COLLECTION_SECTION_SUCCEDDED: 
      var id = action.payload.collection;
      var sectionId = action.payload.section.id;

      if(!state.item || state.item.id != id){
        return state
      }

      var currentCollection = state.item;

      var sections = currentCollection.sections.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            ...action.payload.section,
            loading: false,
            fetched: true
          }
        } else {
          return section;
        }
      })
      
      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          sections: sections
        }
      });
    
    case CREATE_COLLECTION_SECTION_REQUEST: 
      var id = action.payload.id;
      var name = action.payload.name;

      if(!state.item || state.item.id != id){
        return state
      }

      var sections = state.item.sections || [];
      sections = [...sections, {
        name: name,
        internal_id: guid(),
        loading: false,
        fetched: true
      }];

      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          sections: sections
        }
      })        

    case UPDATE_COLLECTION_SECTION_REQUEST: 
      var id = action.payload.id;
      var index = action.payload.index;
      var name = action.payload.name;

      if(!state.item || state.item.id != id){
        return state
      }

      var sections = state.item.sections || [];
      sections = sections.map((section, i) => {
        if(index == i){
          return Object.assign({}, section, {
            ...section,
            name: name
          })  
        }

        return section;
      })


      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          sections: sections
        }
      })    

    case REMOVE_COLLECTION_SECTION_REQUEST: 
      var id = action.payload.id;
      var index = action.payload.index;

      if(!state.item || state.item.id != id){
        return state
      }

      var sections = state.item.sections || [];
      sections = sections.filter((section, i) => {
        return index != i;
      });

      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          sections: sections
        }
      })

    case COLLECTION_MOVE_SECTIONS: 
      var id = action.payload.id;
      
      if(!state.item || state.item.id != id){
        return state
      }

      var sections = state.item.sections || [];
      sections = [...sections];
      sections.splice(action.payload.to, 0, sections.splice(action.payload.from, 1)[0]);

      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          sections: sections
        }
      })

    case COLLECTION_ADD_ASSETS:
      var id = action.payload.id;
      var index = action.payload.section;
      var assets = action.payload.assets;
      const viewerType = _.get(state,"item.viewerType");

      if(!state.item || state.item.id != id){
        return state;
      }

      if(index != null && index >= 0 && state.item.sections){
        var sections = state.item.sections.map((section, i) => {
          if(index != i){
            return section;
          }

          var existingAssets = section.assets || [];

          assets = assets.filter((asset) => {
            var found = existingAssets.find((item) => {
              return item.id == asset.id;
            })

            return found == null
          });
          return Object.assign({}, section, {
            ...section,
            assets: viewerType === EXPERIENCE_BENTO ? [...existingAssets, ...assets] : [...assets, ...existingAssets]
          })  
        });

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            sections: sections
          }
        })
      }else{
        var existingAssets = state.item.assets || [];

        assets = assets.filter((asset) => {
          var found = existingAssets.find((item) => {
            return item.id == asset.id;
          })

          return found == null
        });

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            assets: viewerType === EXPERIENCE_BENTO ? [...existingAssets, ...assets] : [...assets, ...existingAssets]
          }
        });
      }

    case COLLECTION_REMOVE_ASSETS:
      var id = action.payload.id;
      var index = action.payload.section;
      var asset = action.payload.asset;

      if(!state.item || state.item.id != id){
        return state
      }

      if(index != null && index >= 0 && state.item.sections){
        var sections = state.item.sections.map((section, i) => {
          if(index != i){
            return section;
          }

          var assets = section.assets || [];
          assets = assets.filter((item) => {
            return item.id != asset
          });

          return Object.assign({}, section, {
            ...section,
            assets: assets
          })  
        });

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            sections: sections
          }
        })
      }else{
        var assets = state.item.assets || [];
        assets = assets.filter((item) => {
          return item.id != asset
        });

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            assets: assets
          }
        });
      }  

      return state;

    case COLLECTION_REARRANGE_ASSETS:
      var id = action.payload.id;
      var index = action.payload.section;
      var asset = action.payload.asset;

      if(!state.item || state.item.id != id){
        return state
      }

      if(index != null && index >= 0 && state.item.sections){
        var sections = state.item.sections.map((section, i) => {
          if(index != i){
            return section;
          }

          var assets = section.assets || [];
          assets = [...assets];

          var asset = assets[action.payload.from];
          var assetIndex = assets.findIndex(item => {
            return item.id === asset.id;
          })

          var sourceAsset = assets[assetIndex];
          assets.splice(assetIndex, 1);
          assets.splice(action.payload.to, 0, sourceAsset);

          return Object.assign({}, section, {
            ...section,
            assets: assets
          })  
        });

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            sections: sections
          }
        })
      }else{
        var assets = state.item.assets || [];
        assets = [...assets];
        var asset = assets[action.payload.from];
        var assetIndex = assets.findIndex(item => {
          return item.id === asset.id;
        })

        var sourceAsset = assets[assetIndex];
        assets.splice(assetIndex, 1);
        assets.splice(action.payload.to, 0, sourceAsset);

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            assets: assets
          }
        });
      }  

      return state;

    case COLLECTION_UPDATE_PROPERTY:
      var id = action.payload.id;
      var property = action.payload.property;
      var value = action.payload.value;

      if(!state.item || state.item.id != id){
        return state
      }

      return Object.assign({}, state, {
        ...state,
        item: {
          ...state.item,
          [property]: value
        }
      });
    
    case COLLECTION_HIGHLIGHT_SECTION_DRAG_OVER:
      var collection = action.payload.collection;
      var index = action.payload.section;
      var asset = action.payload.asset;

      if(!state.item || state.item.id != collection){
        return state
      }

      const section = state.item.sections[index];
      var sectionId = section.id ? section.id : section.internal_id;

      return Object.assign({}, state, {
        ...state,
        move: {
          section: sectionId,
          asset: asset
        }
      });
    
    case INVALIDATE_COLLECTION_MOVE_ASSET_BETWEEN_SECTIONS:
      return Object.assign({}, state, {
        ...state,
        move: {
          section: null,
          asset: null
        }
      });


    case UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION: {
      const sectionIndex = _.get(action, 'payload.section');
      const collectionId = _.get(action, 'payload.collection');
      const assetsToUpdate = _.get(action, 'payload.assets');
      var activeCollection = state.item;

      if (!activeCollection || activeCollection.id != collectionId) {
        return state;
      }
      

      if (_.size(activeCollection.sections) > 0 && sectionIndex) {
        const updatedSections = activeCollection.sections.map((section, index) => {
          if (index == sectionIndex) {
            return {
              ...section,
              assets: _.get(section, "assets", []).map(asset => {
                const assetToUpdate = _.find(assetsToUpdate, { id: asset.id });
                if (assetToUpdate) {
                  const dimension = assetToUpdate.dimension;
                  return {
                    ...asset,
                    additionalMetadata: {
                      xaxis: dimension.x,
                      yaxis: dimension.y,
                      width: dimension.width,
                      height: dimension.height
                    }
                  }
                }

                return asset;
              })
            }
          }

          return section;
        })
        
        return {
          ...state,
          item: {
            ...state.item,
            sections: updatedSections
          }
        }
      }
      else {
        const assets = activeCollection.assets;
        var updatedAssets = assets.map(asset => {
          const assetToUpdate = _.find(assetsToUpdate, { id: asset.id });
          if (assetToUpdate) {
            const dimension = assetToUpdate.dimension;
            return {
              ...asset,
              additionalMetadata: {
                xaxis: dimension.x,
                yaxis: dimension.y,
                width: dimension.width,
                height: dimension.height
              }
            }
          }

          return asset;
        });

        return {
          ...state,
          item: {
            ...state.item,
            assets: updatedAssets
          }
        }
      }
    }

      case REPLACE_SIMILAR_ASSET_SUCCEEDED: {
      var newAssetId = action.payload.newAssetId;
      var existingAsset = action.payload.existingAsset;

      if (state.item && state.item.sections && state.item.sections.length > 0) {
        var sections = state.item.sections.map((section) => {
          if (section.fetched) {
            var existingAssets = section.assets || [];

            var newAsset = _.find(existingAssets, (asset) => {
              return asset.id === newAssetId;
            });

            if (newAsset) {
              var assets = existingAssets.map((asset) => {
                if (asset.id === newAssetId) {
                  return existingAsset;
                }
                return asset;
              });

              assets = _.uniqBy(assets, "id");

              return Object.assign({}, section, {
                ...section,
                assets: assets,
              });
            }
          } else return section;
        });

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            sections: sections,
          },
        });
      } else {
        var existingAssets = state.item ? state.item.assets : [];

        if (_.isEmpty(existingAssets)) {
          return state;
        }

        var newAsset = _.find(existingAssets, (asset) => {
          return asset.id === newAssetId;
        });

        if (newAsset) {
          var assets = existingAssets.map((asset) => {
            if (asset.id === newAssetId) {
              return existingAsset;
            }
            return asset;
          });

          assets = _.uniqBy(assets, "id");

          return Object.assign({}, state, {
            ...state,
            item: {
              ...state.item,
              assets: assets,
            },
          });
        }
      }
    }

    default:
      return state
  }
}  